import type { HeadingTagType } from '@lexical/rich-text'

export type BlockType = 'paragraph' | 'quote' | HeadingTagType

export type ToolbarOptions = {
  history?: boolean
  blockType?: boolean
  fontSize?: boolean
  bold?: boolean
  italic?: boolean
  underline?: boolean
  link?: boolean
  alignment?: boolean
}

export const DEFAULT_TOOLBAR: Required<ToolbarOptions> = {
  history: true,
  blockType: true,
  fontSize: true,
  bold: true,
  italic: true,
  underline: true,
  link: true,
  alignment: true
}

export type TextEditorProps = {
  state?: object | string | null
  html?: string | null
  stateName: string
  htmlName: string
  maxLength?: number
  placeholder?: string
  toolbar?: ToolbarOptions
  singleLine?: boolean
}

export type ToolbarStateProps = {
  canUndo: boolean
  canRedo: boolean
  blockType: string
  isBold: boolean
  isItalic: boolean
  isUnderline: boolean
  isLink: boolean
  fontSize: number
  elementFormat: string
}

// guards
export const isHeadingTag = (value: string): value is HeadingTagType => {
  return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value)
}
